/**
 * Streams SDK error payloads are plain objects (e.g. softphone errors carry
 * `{ type, message, endPointUrl, errorType, exception }`). `String(err)` on
 * those yields `"[object Object]"` and discards every diagnostic field, so
 * use this helper at every SDK error logging site instead.
 */
export function serializeStreamsError(err: unknown): Record<string, unknown> {
    if (err == null) return { value: String(err) };
    if (typeof err !== 'object') return { value: String(err) };

    const e = err as Record<string, unknown>;
    const out: Record<string, unknown> = {};

    const knownKeys = [
        'type',
        'message',
        'endPointUrl',
        'errorType',
        'exception',
        'name',
        'code',
        'stack',
        'reason',
        'cause',
    ];
    for (const key of knownKeys) {
        if (e[key] !== undefined) out[key] = e[key];
    }

    try {
        out._json = JSON.stringify(e, Object.getOwnPropertyNames(e));
    } catch {
        // Circular or otherwise non-serializable; the known-keys extraction above is the fallback.
    }

    return out;
}
